import * as Sentry from '@sentry/react'
import { env } from './env'

export function initSentry() {
  if (!env.VITE_SENTRY_DSN) {
    console.debug('Sentry disabled: no DSN provided')
    return
  }

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
